module.exports = __webpack_public_path__ + "media/images/athletes/2901-2e7f0d88664bb972fcc1605da340fc6a.png";